import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Conditionnement} from "../models/Conditionnements/Conditionnement";
import {BehaviorSubject, lastValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConditionnementService {
  apiGccUrl = environment.api + 'bff/';

  allConditionnements$ = new BehaviorSubject<Conditionnement[] | null>(null)

  constructor(private http: HttpClient) { }


  async getAllConditionnements(){
    const condis = await lastValueFrom(this.http.get<Conditionnement[]>(this.apiGccUrl + "Conditionnements/GetAllConditionnements"))
    this.allConditionnements$.next(condis);
  }

  getConditionnementsForCart(idVin: string, millesime: string) {
    return this.http.get<Conditionnement[]>(this.apiGccUrl + "Conditionnements/GetConditionnementsBySupplementVin", {params: {idVin, millesime}})
  }
}
